import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-dashboard-notification-preloader',
    templateUrl: './dashboard-notification-preloader.component.html',
    styleUrls: ['./dashboard-notification-preloader.component.scss'],
    standalone: true
})
export class DashboardNotificationPreloaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
